import { ApolloProvider } from '@apollo/client'
import React from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import { Normalize } from 'styled-normalize'
import ErrorBoundary from './components/ErrorBoundary'
import client from './graphql/client'
import Router from './router'
import theme from './utils/theme'

import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

const GlobalStyle = createGlobalStyle`
    body{
        background: #eee;
        max-width: 750px;
        margin: auto;
        position: relative;
    }
    a{
        text-decoration: none;
    }
    .sc-ion-searchbar-ios-h{
        padding-bottom: 1px !important;
    }
    .searchbar-input.sc-ion-searchbar-md{
        box-shadow: none;
        border: 1px solid #eee;
        border-radius: 25px;
    }
`

export default () => (
    <ApolloProvider client={client}>
        <ErrorBoundary>
            <ThemeProvider theme={theme}>
                <Normalize />
                <GlobalStyle />
                <Router />
            </ThemeProvider>
        </ErrorBoundary>
    </ApolloProvider>
)
